import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { ProjectForWorkspacesList } from '../../fragments/generated/ProjectForWorkspacesList';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetProjectsForWorkspacesListQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  projectsPage: Types.PageInput;
  fullAccessProjectsPage: Types.PageInput;
  partialAccessProjectsPage: Types.PageInput;
  query?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy: Types.ProjectOrderInput;
  filters?: Types.InputMaybe<Array<Types.ProjectStatusInput>>;
}>;


export type GetProjectsForWorkspacesListQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, projects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, private: boolean, archivedAt?: string | null, name: string, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, fullAccessProjects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, private: boolean, archivedAt?: string | null, name: string, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } }, partialAccessProjects: { __typename?: 'ProjectConnection', nodes: Array<{ __typename?: 'Project', id: string, private: boolean, archivedAt?: string | null, name: string, images: { __typename?: 'Images', image32?: string | null, image64?: string | null, image128?: string | null, image256?: string | null, imageBase?: string | null, original?: string | null }, workspace?: { __typename?: 'Workspace', id: string, name: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } } | null };


export const GetProjectsForWorkspacesList = /*#__PURE__*/ gql`
    query GetProjectsForWorkspacesList($accountId: ID!, $projectsPage: PageInput!, $fullAccessProjectsPage: PageInput!, $partialAccessProjectsPage: PageInput!, $query: String, $sortBy: ProjectOrderInput!, $filters: [ProjectStatusInput!]) {
  account(accountId: $accountId) {
    id
    projects(
      page: $projectsPage
      filter: {projectStatus: $filters, query: $query}
      orders: [{field: WORKSPACE_NAME, direction: ASC}, $sortBy]
    ) {
      nodes {
        ...ProjectForWorkspacesList
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    fullAccessProjects(page: $fullAccessProjectsPage) {
      nodes {
        ...ProjectForWorkspacesList
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    partialAccessProjects(page: $partialAccessProjectsPage) {
      nodes {
        ...ProjectForWorkspacesList
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${ProjectForWorkspacesList}` as unknown as DocumentNode<GetProjectsForWorkspacesListQuery, GetProjectsForWorkspacesListQueryVariables>;

          

          export const useGetProjectsForWorkspacesListQuery = (options?:QueryHookOptions<GetProjectsForWorkspacesListQuery, GetProjectsForWorkspacesListQueryVariables>) => useQuery(GetProjectsForWorkspacesList, options);

          

          export type GetProjectsForWorkspacesListQueryOptions = QueryHookOptions<GetProjectsForWorkspacesListQuery, GetProjectsForWorkspacesListQueryVariables>;

          

          export const useGetProjectsForWorkspacesListLazyQuery = (options?:LazyQueryHookOptions<GetProjectsForWorkspacesListQuery, GetProjectsForWorkspacesListQueryVariables>) => useLazyQuery(GetProjectsForWorkspacesList, options);

          

          export type GetProjectsForWorkspacesListQueryResult = ReturnType<typeof useGetProjectsForWorkspacesListQuery>;

          
